/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import "../../EmployeeScreens/EmployeeProfile/EMPProfile.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import axios from "axios";
import moment from "moment";
import Loader from "../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useProfile } from "../../../Context/ProfileContext";

const AdminProfile = () => {
  const navigate = useNavigate();
  const { profileData, fetchProfile } = useProfile();
  const [errorFirstName, setErrorFirstName] = useState(false);
  const [errorLastName, setErrorLastName] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [errorEmergencyContactNumber, setErrorEmergencyContactNumber] =
    useState(false);
  const [errorMobile, setErrorMobile] = useState();
  const [errorAddress, setErrorAddress] = useState(false);
  const [newImageUrl, setNewImageUrl] = useState("");
  const [photoExtension, setPhotoExtension] = useState("");
  const fileInputRef = useRef(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [ProfileData, setProfileData] = useState("");
  const [loading, setLoading] = useState(false);
  const [adhaarImageUrl, setAdhaarImageUrl] = useState("");
  const [adhaarExtension, setAdhaarExtension] = useState("");
  const adhaarFileInputRef = useRef(null);
  const [errorMaritalStatus, setErrorMaritalStatus] = useState(false);
  const [errorAdhaar, setErrorAdhaar] = useState(false);
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [adhaarImageFiles, setAdhaarImageFiles] = useState([]);
  const LoginToken = GetToken();

  const [profileAlldata, setProfileAllData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Mobile: "",
    Gender: "",
    MaritalStatus: "",
    DateOfBirth: "",
    Department: "",
    Designation: "",
    Address: "",
    UrlLink: "",
    AdhaarLink: "",
    Emergencycontactno: "",
    TeamLeads: "",
  });

  const validate = () => {
    if (!profileAlldata?.FirstName) {
      setErrorFirstName("userFirstName");
      return false;
    }
    if (!profileAlldata?.Mobile) {
      setErrorMobile("userMobile");
      return false;
    }
    if (!profileAlldata?.Emergencycontactno) {
      setErrorEmergencyContactNumber("userEmergencyContactNumber");
      return false;
    }
    if (!profileAlldata?.Address) {
      setErrorAddress("userAddress");
      return false;
    }
    return true;
  };

  const Gender = [
    { value: "Male", label: "Male", id: 0 },
    { value: "Female", label: "Female", id: 1 },
    { value: "Transgender", label: "Transgender", id: 2 },
  ];

  const MaritalStatusOptions = [
    { value: "Single", label: "Single", id: 0 },
    { value: "Married", label: "Married", id: 1 },
    { value: "Divorced", label: "Divorced", id: 2 },
    { value: "Widowed", label: "Widowed", id: 3 },
  ];

  useEffect(() => {
    setProfileData((prevProfileData) => ({
      ...prevProfileData,
      Mobile: prevProfileData.Mobile || "",
      Gender: prevProfileData.Gender || "",
      DateOfBirth: prevProfileData.DateOfBirth || "",
      Department: prevProfileData.Department || "",
    }));
  }, []);

  useEffect(() => {
    if (profileData) {
      const gender = Gender?.find((e) => e?.id === profileData?.Gender);
      const maritalStatus = MaritalStatusOptions?.find(
        (e) => e?.id === profileData?.MaritalStatus
      );

      setProfileData(profileData);

      setProfileAllData({
        ...profileAlldata,
        FirstName: profileData?.FirstName,
        LastName: profileData?.LastName,
        Email: profileData?.Email,
        Mobile: profileData?.Mobile?.slice(0, 10),
        DateOfBirth: profileData?.DateOfBirth,
        Gender: gender,
        Department: profileData?.Departments?.Name,
        Designation: profileData?.Designations?.DesignationName,
        Address: profileData?.Address,
        UrlLink: profileData?.UrlLink,
        Emergencycontactno: profileData?.Emergencycontactno,
        TeamLeads: profileData?.TeamLeads?.UserName,
        MaritalStatus: maritalStatus,
        AdhaarLink: profileData?.AadharCard,
      });
    }
  }, [profileData]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result;
        setProfileAllData((prev) => ({
          ...prev,
          UrlLink: base64Image,
        }));
        setNewImageUrl(base64Image);
      };
      reader.readAsDataURL(file);

      const photoExtension = file.type.split("/")[1];
      setPhotoExtension(photoExtension);
      setProfileImageFile(file);
    }
  };

  const handleAdhaarChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);

      if (fileArray.length > 2) {
        toast.error("Maximum 2 files allowed for Aadhaar upload");
        e.target.value = "";
        return;
      }

      setAdhaarImageFiles(fileArray);

      if (fileArray.length > 0) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setAdhaarImageUrl(reader.result);
          setProfileAllData((prev) => ({
            ...prev,
            AdhaarLink: reader.result,
          }));
        };
        reader.readAsDataURL(fileArray[0]);
      }
    }
  };

  const handleUpdateProfile = (clicked) => {
    if (!validate()) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("Id", ProfileData?.Id);
    formData.append("FirstName", profileAlldata?.FirstName);
    formData.append("LastName", profileAlldata?.LastName);
    formData.append("Gender", profileAlldata?.Gender?.id);
    formData.append("Mobile", profileAlldata?.Mobile);
    formData.append("Address", profileAlldata?.Address);
    formData.append("DateOfBirth", profileAlldata?.DateOfBirth);
    formData.append("PhotoExtenssion", photoExtension ? photoExtension : "");
    formData.append("Emergencycontactno", profileAlldata?.Emergencycontactno);

    if (profileAlldata?.MaritalStatus?.id !== undefined) {
      formData.append("MaritalStatus", profileAlldata?.MaritalStatus?.id);
    }

    if (profileAlldata?.UrlLink) {
      const base64Photo = profileAlldata?.UrlLink?.split("base64,")?.[1] || "";
      if (base64Photo) {
        formData.append("Photo", base64Photo);
      }
    }

    if (profileAlldata?.AdhaarLink) {
      const base64Adhaar =
        profileAlldata?.AdhaarLink?.split("base64,")?.[1] || "";
      if (base64Adhaar) {
        formData.append("AadharCard", base64Adhaar);
      }
    }

    if (adhaarImageFiles && adhaarImageFiles.length > 0) {
      adhaarImageFiles.forEach((file) => {
        formData.append("AadharFiles", file);
      });
    }

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/UpdateProfile`,
      data: formData,
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (clicked === "update") {
          setDummy(true);
        }
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setProfileImageFile(null);
          setAdhaarImageFiles([]);
          setTimeout(() => fetchProfile(), 500);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />

        <section
          className={
            showSidebar
              ? "EMP-profile-main-section"
              : "EMP-profile-main-section-new"
          }
        >
          <div className="EMP-profile-all-icons">
            <div>
              <p className="MAIN-HEADING">Profile </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Profile </p>
              <MdKeyboardArrowRight />
              <p> Profile </p>
            </div>
          </div>

          <div className="EMP-profile-main-container">
            <div className="EMP-profile-outter-container">
              <div className="EMP-profile-inner-container">
                <div className="EMP-profile-heading">
                  <p> Profile</p>
                </div>

                <div className="EMP-profile-inner-box row">
                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="FirstName*"
                      value={profileAlldata.FirstName || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          FirstName: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorFirstName("userFirstName");
                        } else {
                          setErrorFirstName("false");
                        }
                      }}
                    />
                    {errorFirstName === "userFirstName" &&
                    !profileAlldata?.FirstName ? (
                      <span className="contact_error-dob">
                        First name is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="LastName"
                      value={profileAlldata?.LastName || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          LastName: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorLastName("userLastName");
                        } else {
                          setErrorLastName("false");
                        }
                      }}
                    />
                    {errorLastName === "userLastName" &&
                    !profileAlldata?.LastName ? (
                      <span className="contact_error-dob">
                        Last name is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs-disabled col-6">
                    <FloatingLabelInput
                      label="Email*"
                      value={profileAlldata?.Email?.trim() || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Email: e?.target?.value,
                        })
                      }
                      style={{ marginBottom: 0 }}
                      disabled
                    />
                  </div>

                  <div className="profile-inputs-disabled col-6">
                    <FloatingLabelInput
                      label="Gender*"
                      value={profileAlldata.Gender?.label || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Gender: e?.target?.value,
                        })
                      }
                      disabled
                    />
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Mobile*"
                      maxLength="10"
                      value={profileAlldata.Mobile || ""}
                      onChange={(e) => {
                        const inputMobile = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData({
                          ...profileAlldata,
                          Mobile: inputMobile,
                        });
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorMobile("userMobile");
                        } else {
                          setErrorMobile("false");
                        }
                      }}
                    />
                    {errorMobile === "userMobile" &&
                    !profileAlldata?.Mobile ? (
                      <span className="contact_error-dob">
                        Mobile no is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Emergency Contact*"
                      maxLength="10"
                      value={profileAlldata?.Emergencycontactno || ""}
                      onChange={(e) => {
                        const inputMobile = e?.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData({
                          ...profileAlldata,
                          Emergencycontactno: inputMobile,
                        });
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorEmergencyContactNumber(
                            "userEmergencyContactNumber"
                          );
                        } else {
                          setErrorEmergencyContactNumber("false");
                        }
                      }}
                    />
                    {errorEmergencyContactNumber ===
                      "userEmergencyContactNumber" &&
                    !profileAlldata?.Emergencycontactno ? (
                      <span className="contact_error-dob">
                        Emergency contact no is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <label htmlFor="">Date Of Birth</label>
                    <input
                      type="date"
                      label="DateOfBirth*"
                      value={moment(profileAlldata?.DateOfBirth).format(
                        "YYYY-MM-DD"
                      )}
                      onChange={(e) => {
                        const formattedDate = moment(e?.target?.value).format(
                          "DD MMMM YYYY"
                        );
                        setProfileAllData({
                          ...profileAlldata,
                          DateOfBirth: formattedDate,
                        });
                      }}
                    />
                  </div>

                  <div className="profile-inputs col-6">
                    <label htmlFor="" className="label-manaegement-section">
                      Marital Status
                    </label>
                    <select
                      className="profile-select-input"
                      value={profileAlldata?.MaritalStatus?.id ?? ""}
                      onChange={(e) => {
                        const selectedStatus = MaritalStatusOptions.find(
                          (status) => status.id === parseInt(e.target.value)
                        );
                        setProfileAllData({
                          ...profileAlldata,
                          MaritalStatus: selectedStatus,
                        });
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorMaritalStatus("userMaritalStatus");
                        } else {
                          setErrorMaritalStatus("false");
                        }
                      }}
                    >
                      <option value="">Select Marital Status</option>
                      {MaritalStatusOptions.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                    {errorMaritalStatus === "userMaritalStatus" &&
                    !profileAlldata?.MaritalStatus ? (
                      <span className="contact_error-dob">
                        Marital Status is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs-for-image col-6">
                    <label htmlFor="profileImage">Profile Image</label>
                    <div className="profile-inputs-for-image-inner-div profile-upload-row">
                      <input
                        type="file"
                        id="profileImage"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                        accept="image/*"
                      />

                      <label htmlFor="profileImage" className="custom-file-btn">
                        Choose File
                      </label>

                      <div className="image-preview-right-box">
                        {newImageUrl ? (
                          <img
                            className="image-of-profile"
                            src={newImageUrl || "/placeholder.svg"}
                            alt="ProfileImage"
                          />
                        ) : profileAlldata?.UrlLink ? (
                          <img
                            className="image-of-profile"
                            src={profileAlldata?.UrlLink || "/placeholder.svg"}
                            alt="ProfileImage"
                          />
                        ) : (
                          <span className="upload-placeholder-text">
                            No image selected
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="profile-inputs-for-image col-6">
                    <label htmlFor="adhaarImage">Adhaar Upload (Multiple Files)</label>
                    <div className="profile-inputs-for-image-inner-div profile-upload-row">
                      <input
                        type="file"
                        id="adhaarImage"
                        ref={adhaarFileInputRef}
                        onChange={handleAdhaarChange}
                        multiple
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      />

                      <label htmlFor="adhaarImage" className="custom-file-btn">
                        Choose File
                      </label>

                      <div className="image-preview-right-box">
                        {adhaarImageUrl ? (
                          <img
                            className="image-of-profile"
                            src={adhaarImageUrl || "/placeholder.svg"}
                            alt="AdhaarImage"
                          />
                        ) : profileAlldata?.AdhaarLink ? (
                          <img
                            className="image-of-profile"
                            src={profileAlldata?.AdhaarLink || "/placeholder.svg"}
                            alt="AdhaarImage"
                          />
                        ) : (
                          <span className="upload-placeholder-text">
                            Click to upload Adhaar
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {profileAlldata.Department ? (
                    <div className="profile-inputs-disabled col-4 ">
                      <FloatingLabelInput
                        label="Department*"
                        value={profileAlldata.Department}
                        onChange={(e) =>
                          setProfileAllData({
                            ...profileAlldata,
                            Department: e?.target?.value,
                          })
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  {profileAlldata?.Designation ? (
                    <div className="profile-inputs-disabled col-4">
                      <FloatingLabelInput
                        label="Designation*"
                        value={profileAlldata?.Designation}
                        onChange={(e) =>
                          setProfileAllData({
                            ...profileAlldata,
                            Designation: e?.target?.value,
                          })
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  {profileAlldata?.TeamLeads ? (
                    <div className="profile-inputs-disabled col-4">
                      <FloatingLabelInput
                        label="Team Lead*"
                        value={profileAlldata?.TeamLeads}
                        onChange={(e) =>
                          setProfileAllData({
                            ...profileAlldata,
                            TeamLeads: e?.target?.value,
                          })
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  <div className="profile-text-area col-md12">
                    <label htmlFor="">Address</label>
                    <textarea
                      id=""
                      cols="30"
                      rows="8"
                      value={profileAlldata.Address}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Address: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorAddress("userAddress");
                        } else {
                          setErrorAddress("false");
                        }
                      }}
                    />
                    {errorAddress === "userAddress" &&
                    !profileAlldata?.Address ? (
                      <span className="contact_error-dob">
                        Address is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-buttons">
                    <button
                      className="Profile-submit-button"
                      onClick={() => handleUpdateProfile("update")}
                    >
                      {profileAlldata ? "Update" : "submit"}
                    </button>
                    <button className="Profile-Cancel-button"> Cancel </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminProfile;